/* eslint-disable no-throw-literal */
import { LONGEST_VIN_LENGTH } from 'shared/constants';

export const getDataIndexByPropName = (data, propName, value) => {
  try {
    return data.findIndex((item) => item[propName] === value);
  } catch (err) {
    console.error('getDataIndexByPropName', {
      data,
      err,
      propName,
      value,
    });
  }
  return null;
};

export const getListDataById = (data, propName, id) => {
  try {
    return data.filter((item) => item[propName] === id);
  } catch (err) {
    console.error('getListDataById', {
      data,
      err,
      id,
      propName,
    });
  }
  return [];
};

export const hasData = (data) => {
  try {
    return data && !!data;
  } catch (err) {
    console.error('hasData', { data, err });
  }
  return false;
};

export const getProductAttribute = (data, key, noDataPlaceholderText) => {
  try {
    const attr = data && getListDataById(data.attributes || [], 'name', key)[0];
    return attr ? attr.value : noDataPlaceholderText;
  } catch (err) {
    console.error('getProductAttribute', {
      data,
      err,
      key,
      noDataPlaceholderText,
    });
  }
  return null;
};

export const getAttributeItem = (value, attributes) => {
  if (!attributes) {
    return null;
  }
  const attr = attributes.filter((item) => item.name === value);

  if (attr.length === 0) {
    return null;
  }

  return attr[0];
};

export const getCrJsonProp = (report, key) =>
  report?.value && JSON.parse(report.value)[key];
export const getCrValue = (item) =>
  item?.Score !== '-' ? `${item.Option} (${item.Score})` : item.Option;

export const getCrScore = (total, mechanical, cosmetic) => {
  if (!total || total === '') return 'Not Available';
  if (cosmetic === '' || mechanical === '') return `Score: ${total}`;
  return `${total} (Mech: ${mechanical}; Cosm: ${cosmetic})`;
};

export const convertArrayToObject = (data, key) => {
  try {
    return data.reduce(
      (obj, item) => Object.assign(obj, { [item[key]]: item.value }),
      {},
    );
  } catch (err) {
    console.error('convertArrayToObject', { data, err, key });
  }
};

export const toTitleCase = (val) => {
  const value = val || '';
  if (typeof value !== 'string') throw 'Argument must be a string';

  return value.trim().replace(/\w\S*/g, (txt) => {
    if (txt.length === 1) return txt.toUpperCase();
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const mapToObj = (strMap) => {
  const obj = Object.create(null);
  for (const [key, value] of strMap) {
    obj[key] = value;
  }
  return obj;
};

export const toBoolean = (str) => {
  //https://stackoverflow.com/questions/3263161/cannot-set-boolean-values-in-localstorage
  if (typeof str === 'undefined' || str === null) {
    return false;
  }
  if (typeof str === 'string') {
    switch (str.toLowerCase()) {
      case '':
      case '0':
      case 'false':
      case 'no':
        return false;
      default:
        return true;
    }
  } else if (typeof str === 'number') {
    return str !== 0;
  } else if (typeof str === 'boolean') {
    return str;
  } else {
    return true;
  }
};

export const mergeArrayObjects = (ar1, obj, key) => {
  return ar1.map((item) => {
    if (item[key] === obj[key]) {
      return Object.assign({}, item, obj);
    } else {
      return item;
    }
  });
};

export const getQuerystringValue = (key) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(key);
};

export const messagePrettier = (str, chunkSize = LONGEST_VIN_LENGTH) => {
  const sanitizedMessage = str
    .trim()
    .replace(/[^a-zA-Z0-9\+\-\$\.\?\)\(#! _,]/g, '')
    .trim();
  if (sanitizedMessage.length === 0) return '';
  const parts = sanitizedMessage.split(' ');
  return parts
    .filter((word) => word.length > 0)
    .map((word) =>
      word.match(new RegExp('.{1,' + chunkSize + '}', 'g')).join(' '),
    )
    .join(' ');
};
